export const RoomQuoteStatus = {
  Error: 0,
  Check: 1,
  Success: 2,
  OverCapacity: 3,
  NoInventory: 4,
  NoRates: 5,
  NoQuotes: 6,
}
